export const IMAGE_CROPPER_TEXT = `This image's aspect ratio must match the thumbnail frame of the widget it will display in.`;
